<template>
  <div class="table_wrap">
    <el-table class="list-table" header-cell-class-name="list-header" :data="utilityData">
      <el-table-column label="사용 당시 연결된 아이템" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.i_name }}
        </template>
      </el-table-column>
      <el-table-column label="사용 당시 소유자 아이디" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.use_mb_id }}
        </template>
      </el-table-column>
      <el-table-column label="사용 당시 소유자 닉네임" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.use_mb_nick }}
        </template>
      </el-table-column>
      <el-table-column label="사용현황" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.uu_use_cnt }} / {{ row.u_use_total }}
        </template>
      </el-table-column>
      <el-table-column label="사용일" class-name="text-center">
        <template v-slot="{ row }">
          {{ row.use_created_at }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import dateMixins from "@/mixins/dateMixins"

export default {
  name: "UtilityListUseLayout",
  mixins: [dateMixins],
  components: {},
  inject: [],
  provide() {
    return {};
  },
  props: {
    utilityData: {
      default: () => {
        return [];
      },
    },
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      },
    },
  },
  data() {
    return {};
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
  },
  watch: {},
};
</script>

<style scoped></style>
